import React from 'react'
import { FieldErrors } from 'react-hook-form/dist/types'

import FormErrorAlert from 'Shared/atoms/FormErrorAlert'
import { getAdditionalValidationFields, getFailedValidationFields } from 'Shared/utils/validation'

interface Props {
	errors: FieldErrors
	errorPrefix: string
	labels: { [key: string]: string }
	showRequiredFields?: boolean
	className?: string
	showAdditionalFieldErrors?: boolean
	isPositionFixed?: boolean
}

const FormError: React.FC<Props> = ({
	errorPrefix,
	errors,
	labels,
	className,
	isPositionFixed,
	showAdditionalFieldErrors = false,
	showRequiredFields = false
}) => {
	const failedValidationFields = errors
		? getFailedValidationFields(errors, labels, showRequiredFields)
		: []

	const additionalFieldErrors = showAdditionalFieldErrors
		? getAdditionalValidationFields(errors)
		: []

	return (
		<FormErrorAlert
			errorPrefix={errorPrefix}
			isPositionFixed={isPositionFixed}
			className={className}
			additionalFieldErrors={additionalFieldErrors}
			failedValidationFields={failedValidationFields}
		/>
	)
}

export default FormError
